import { DisclaimerContent } from 'app/components/commons/DisclaimerContent/DisclaimerContent';
import { DisclaimerKind } from 'app/typings/disclaimers';

import './Disclaimer.scss';

export const Disclaimer = () => {
  return (
    <div className="disclaimer-content">
      <DisclaimerContent kind={DisclaimerKind.ADVICE} />
      <DisclaimerContent kind={DisclaimerKind.ALERT} />
    </div>
  );
};
